import { InjectionToken } from "@angular/core";

export const OperadoresToken = new InjectionToken("OperadoresToken");
